import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const Page: FunctionComponent<Props> = props => {
    const { children, className = '', testId = TEST_ID } = props;

    return (
        <div className={`${className} ${styles.page}`} data-testid={testId}>
            {children}
        </div>
    );
};

export default Page;
